import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";

const scrollToForm = () =>
  document.getElementById("cotizar")?.scrollIntoView({ behavior: "smooth" });

export const StickyMobileCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 680);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.32, ease: [0.16, 1, 0.3, 1] }}
          data-testid="sticky-mobile-cta"
          className="fixed bottom-0 inset-x-0 z-40 lg:hidden border-t border-gray-200 bg-white/95 backdrop-blur-md px-4 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] shadow-[0_-4px_22px_rgba(10,15,25,0.12)]"
        >
          <button
            type="button"
            onClick={scrollToForm}
            data-testid="sticky-mobile-cta-btn"
            className="group flex h-12 w-full items-center justify-center gap-2 rounded-full bg-brand-ink text-base font-semibold text-white shadow-lg shadow-brand-ink/25 transition-colors hover:bg-brand-inkHover"
          >
            Cotizar mi seguro
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
